<template>
  <div>
    <logged-in-header />
    <refills-stock-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import refillsStockPanel from "../components/refills-stock/RefillsStockPanel";

export default {
  components: { loggedInHeader, refillsStockPanel }
};
</script>
